import React, { useState } from 'react'
// "https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60,w_1700,h_900/https://img.freepik.com/free-vector/dark-gradient-background-with-copy-space_53876-99548.jpg"
const VideoCarousal = ({ pageTitle, videoURL, imageURL, fallbackImage, imageOnly = false, imageAlt }) => {
    const [videoLoaded, setVideoLoaded] = useState(false)

    return (
        <>
            <div id="carouselExampleCaptions" class="carousel slide">
                {/* https://res.cloudinary.com/l7pafu4a/video/fetch/c_scale/q_60/https://res.cloudinary.com/l7pafu4a/video/upload/v1738362738/xp7pv4rw6tjhlosxnysq.mp4 */}
                <div class="carousel-inner">
                    <div  class="carousel-item active">
                    <div style={{ zIndex: '20' }} className='shade'></div>
                        {/* {images.map((e, i) => {

                            return <img src={e.img} class={`d-block w-100 position-${i == counter ? 'relative' : 'absolute'}`} style={{ opacity: i == counter ? '1' : '0', transition: 'all 1s ease' }} alt="..." />

                        })}
                        <img src={window.innerWidth > 750 ? machinelearningimg : machinelearningimgTwo} style={{ top: '0px', opacity: '0.2' }} class="d-block w-100 position-absolute" alt="..." />
                        <div style={{ top: '0px', bottom: '0px', right: '0px', left: '0px' }} class="carousel-caption h-100 w-100 justify-content-center d-flex align-items-center flex-column"> */}
                        <div style={{ backgroundColor: "#000000"}} class="video-carousal d-block w-100 h-100 position-relative" >


                            {!imageOnly && videoURL && (
                                <video
                                    onPlay={() => setVideoLoaded(true)}
                                    loop
                                    autoPlay
                                    muted
                                    playsInline
                                    style={{ top: 0, objectFit: 'cover', height: "100%" }}
                                    className="card-img-top position-absolute"
                                    src={videoURL}
                                />
                            )}
                            <img
                                style={{
                                    transition: "1s all ease",
                                    top: 0,
                                    objectFit: 'cover',
                                    height: "100%",
                                    opacity: imageOnly || !videoLoaded ? 1 : 0
                                }}
                                className="card-img-top position-absolute"
                                src={imageOnly ? imageURL : `https://res.cloudinary.com/l7pafu4a/image/fetch/f_webp/q_60/${imageURL}`}
                                onError={(event) => {
                                    if (fallbackImage && event.currentTarget.src !== fallbackImage) {
                                        event.currentTarget.src = fallbackImage
                                    }
                                }}
                                alt={imageAlt || `${pageTitle} visual`}
                            />


                        </div>

                        <div style={{ top: '0px', bottom: '0px', right: '0px', left: '0px',zIndex:'30' }} class="carousel-caption h-100 w-100 justify-content-center d-flex align-items-center flex-column">

                            <h1 className='display-1 h1 pb-5' style={{ fontFamily: "Barranco" }} >{pageTitle}</h1>
                            <div className="d-flex">
                                {/* {images[counter].iconTwo&&<h1 className='display-1 mx-2' ><i class={`fa-brands ${images[counter].iconTwo} fa-2xl`}></i></h1>} */}

                                {/* <h1 className='display-1 mx-2' ><i class={`${images[counter].icon=='fa-android'?'fa-brands':'fa-solid'} ${images[counter].icon} fa-2xl`}></i></h1> */}
                            </div>
                            {/* <p  style={{fontFamily:"Barranco"}}  className='display-5 pt-5'>{images[counter].offer}</p> */}
                        </div>
                    </div>

                </div>

            </div >
        </>
    )
}

export default VideoCarousal
